export default __webpack_public_path__ + "static/sliding_door_b.5bab62dbdcde33e5b7a5b96b06a58133.png";